import React from 'react';
import { EmergePayIcon } from '../../data/TransactionTypeIcons';

const EmergePayTransactionIcon = () => {
  return (
    <div className="w-8 h-8">
      <EmergePayIcon />
    </div>
  );
};

export default EmergePayTransactionIcon;
